import { Component } from "react";
import { getSessionStorage, setSessionStorage } from "util/storageUtil";

// Deliberately no styled-components / theme context here — this is the
// last-resort fallback for the whole app, so it must render even if
// whatever crashed was itself part of the theme/provider tree.
const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    height: "100vh",
    padding: "24px",
    textAlign: "center",
    fontFamily: "sans-serif",
  },
  message: {
    fontSize: "16px",
    color: "#333",
  },
  button: {
    padding: "12px 24px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#fff",
    background: "#150764",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
};

const isChunkLoadError = (error) =>
  error?.name === "ChunkLoadError" ||
  /Loading (CSS )?chunk .+ failed/i.test(error?.message || "");

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled render error:", error, info);

    // lazyWithRetry already handles the reload-once path for chunk failures
    // triggered during a lazy import(). This covers a ChunkLoadError that
    // surfaces some other way (e.g. thrown outside a lazy() call) without
    // double-reloading one that lazyWithRetry already retried and re-threw.
    if (isChunkLoadError(error) && !getSessionStorage("chunkReloadAttempted")) {
      setSessionStorage("chunkReloadAttempted", true);
      window.location.reload();
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.wrapper}>
          <p style={styles.message}>
            Something went wrong. Please refresh the page.
          </p>
          <button style={styles.button} onClick={this.handleReload}>
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
